import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import APIList from '../../../../http/ApiList';
import { Tag } from 'antd';
import { MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import TypingLabel from '../../../common/typing-text';

const ReportComponentContainer: React.FC<any> = (props) => {
  const { authInfo, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [reportData, setReportData] = useState<any>([]);
  const optionTags = JSON.parse(window.localStorage.getItem('optionTags') || '{}');
  const tagColorMap = {
    Aggressive: '#cf1322', // red,
    Conservative: '#08979c', // cyan,
    Moderate: '#d46b08', // orange
  };
  const getChatData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        if (res?.data) {
          setReportData(res.data);
        } else {
          setReportData(defaultReportData);
        }
      });
  };

  const defaultReportData = [
    {
      title: '財務の安定性・リスク管理',
      contentText:
        '日揮の大型案件における独自モジュール化工法（J・I・ModuleTM工法）や実績の財務がパナンスの具体的な訴求に対する、東洋エンジニアリングの財務マネジメント・リスクマネジメントの具体性の欠如の指摘',
    },
    {
      title: '成長戦略の具体性と多様性',
      contentText: `東洋エンジニアリングは主にEPC事業に依存しており、新規事業の開拓やビジネスモデルの多様化については限られた記載しかありません。一方、日揮グループは、 中期経営計画 「BSP2025」
でEPC事業の深化だけでなく、高機能材製造事業やサ
ステナブルンリューションズ分野の拡大を積極的に進
めています。また、新たな成長エンジンとして水素、
アンモニア、SAF (持続可能な航空燃料)などの新興
分野にも投資を行っており、これが投資家にとって将
来的な収益源の多様化として魅力的に映るでしょう。
東洋エンジニアリングの成長戦略の具体本性と多様性の
欠如は、長期的な成長を期待する投資家にとって弱点
となります。`,
    },
    {
      title: 'サステナビリティへの取り組み',
      contentText: `日揮の具体的なESG戦略および目標値
設定に対する東洋エンジニアリングの
KPIや達成員標の具体性·記述の欠如
に対する指摘`,
    },
    {
      title: '人的資本・組織柔軟性への対応',
      contentText: `日揮の&D推進やジョプ型人事制度の
導入などの具体的な施策に対し、東洋
エンジニアリングの施策はスキルアッ
プ等に避定されている指摘`,
    },
    {
      title: 'グローバル展開・市場対応力',
      contentText: `日揮のエネルギーインフラを基軸にし
た全方位的なグローバル業開に対し、、
東洋エンジニアリングは特定地域に特
化している差分の指摘`,
    },
  ];
  const [detailIndex, setDetailIndex] = useState<number>(1);
  const strategicSelectOption = window.localStorage.getItem('strategicSelectOption');
  const [optionIndex, setOptionIndex] = useState<any>(strategicSelectOption || '3');
  const onDetailClick = (index) => {
    setDetailIndex(index);
  };

  const onOptionClick = (index) => {
    setOptionIndex(index);
  };

  useEffect(() => {
    getChatData(globalEvent);
  }, [globalEvent]);

  useEffect(() => {
    getChatData(globalEvent);
  }, []);

  return (
    <>
      <div
        className="container-layout-area"
        style={{ fontFamily: 'Meiryo SYSTEM-UI', backgroundImage: `url(${property.backgroundImageUrl})`, backgroundSize: 'cover' }}
      >
        <div className="container-search-area">
          <span className="container-title">Top 5 Investors' Comment Forecast Report</span>
        </div>
        {reportData.length === 0 ? (
          <></>
        ) : (
          <>
            <div className="report-area" key={optionIndex}>
              <div className="options-list-area">
                <div className="summary-report-title"> </div>
                <div className="summary-report-items">
                  <div className="options-report-item">
                    <div
                      className={optionIndex === '1' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('1')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-1</div>
                        <Tag
                          color={tagColorMap[optionTags['Option-1'] || 'Aggressive']}
                          style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}
                        >
                          {optionTags['Option-1'] || 'Aggressive'}
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '2' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('2')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-2</div>
                        <Tag
                          color={tagColorMap[optionTags['Option-2'] || 'Moderate']}
                          style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}
                        >
                          {optionTags['Option-2'] || 'Moderate'}
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '3' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('3')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-3</div>
                        <Tag
                          color={tagColorMap[optionTags['Option-3'] || 'Moderate']}
                          style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}
                        >
                          {optionTags['Option-3'] || 'Moderate'}
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '4' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('4')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-4</div>

                        <Tag
                          color={tagColorMap[optionTags['Option-4'] || 'Aggressive']}
                          style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}
                        >
                          {optionTags['Option-4'] || 'Aggressive'}
                        </Tag>
                      </div>
                    </div>
                    <div
                      className={optionIndex === '5' ? 'is-selected-item  options-item' : 'options-item'}
                      onClick={() => onOptionClick('5')}
                    >
                      <div className="options-header">
                        <div className="options-title">Option-5</div>
                        <Tag
                          color={tagColorMap[optionTags['Option-5'] || 'Conservative']}
                          style={{ margin: 0, fontSize: '1rem', padding: '0.3rem' }}
                        >
                          {optionTags['Option-5'] || 'Conservative'}
                        </Tag>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="report-summary-area">
                <div className="summary-report-title">Executive Summary</div>
                <div className="summary-report-items">
                  <div className="summary-report-item">
                    <div className={detailIndex === 1 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(1)}>
                      <div className="item-header">
                        <div className="item-index">1</div>
                        <div className="item-title">{reportData[0].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <TypingLabel
                            text={
                              reportData[0].contentText.length > 90
                                ? reportData[0].contentText.substring(0, 90) + '...'
                                : reportData[0].contentText
                            }
                          />
                        </div>
                      </div>

                      {detailIndex !== 1 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                  </div>
                  <div className="summary-report-item">
                    <div className={detailIndex === 2 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(2)}>
                      <div className="item-header">
                        <div className="item-index">2</div>
                        <div className="item-title">{reportData[1].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <TypingLabel
                            text={
                              reportData[1].contentText.length > 90
                                ? reportData[1].contentText.substring(0, 90) + '...'
                                : reportData[1].contentText
                            }
                          />
                        </div>
                      </div>
                      {detailIndex !== 2 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                    <div className={detailIndex === 3 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(3)}>
                      <div className="item-header">
                        <div className="item-index">3</div>
                        <div className="item-title">{reportData[2].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <TypingLabel
                            text={
                              reportData[2].contentText.length > 90
                                ? reportData[2].contentText.substring(0, 90) + '...'
                                : reportData[2].contentText
                            }
                          />
                        </div>
                      </div>
                      {detailIndex !== 3 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                  </div>
                  <div className="summary-report-item">
                    <div className={detailIndex === 4 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(4)}>
                      <div className="item-header">
                        <div className="item-index">4</div>
                        <div className="item-title">{reportData[3].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <TypingLabel
                            text={
                              reportData[3].contentText.length > 90
                                ? reportData[3].contentText.substring(0, 90) + '...'
                                : reportData[3].contentText
                            }
                          />
                        </div>
                      </div>
                      {detailIndex !== 4 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                    <div className={detailIndex === 5 ? 'is-selected-item  report-item' : 'report-item'} onClick={() => onDetailClick(5)}>
                      <div className="item-header">
                        <div className="item-index">5</div>
                        <div className="item-title">{reportData[4].title}</div>
                      </div>
                      <div className="item-context">
                        <div className="item-text">
                          <TypingLabel
                            text={
                              reportData[4].contentText.length > 90
                                ? reportData[4].contentText.substring(0, 90) + '...'
                                : reportData[4].contentText
                            }
                          />
                        </div>
                      </div>
                      {detailIndex !== 5 ? (
                        <PlusSquareOutlined className="detail-button" />
                      ) : (
                        <MinusSquareOutlined className="detail-button" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {detailIndex !== 0 ? (
                <div className="report-detail-area">
                  <div className="detail-report-title">Comment Forecast Detail</div>
                  <div className="detail-report-items">
                    <div className="detail-item is-selected-item">
                      <div className="item-header">
                        <div className="item-index">{detailIndex}</div>
                        <div className="item-title">{reportData[detailIndex - 1].title}</div>
                      </div>
                      <div className="item-context custom-scrollbar">
                        <div className="item-text">
                          <TypingLabel key={detailIndex} text={reportData[detailIndex - 1].contentTextMore} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReportComponentContainer;
